import saMessages from '../locales/vi_VN.json';
import viVN from 'antd/lib/locale/vi_VN';

const saLang = {
  messages: {
    ...saMessages,
  },
  antLocale: viVN,
  locale: 'vi',
};
export default saLang;
